import {
    HTMLAttributes,
    ReactElement,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Arrowleft } from "../../assets";
import { connect, useDispatch } from "react-redux";
import { menuStatus } from "../../Redux/services/generalService";
import { Collapse } from "@mui/material";

interface Props extends HTMLAttributes<HTMLElement> {
    name?: string;
    icon: any;
    link?: string;
    myStyle?: string;
    userProfile?: boolean;
    subMenu?: any;
    isMini?: boolean;
    headerStatus?: boolean;
    userData?: any

}
export function HeaderItem({ name, icon, link, myStyle, userProfile, subMenu, isMini, headerStatus, userData }: Props): ReactElement {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigation = useNavigate();
    const setStyle = () => {
        let style = `${myStyle}  header-item mt-2 cursor-pointer`
        // if(location.pathname === link && !userProfile || headerStatus ) {
        if ((location.pathname === link && !userProfile && !headerStatus) || (subMenu && subMenu.length > 0 && headerStatus === true)) {
            return style += " active";
        } else {
            return style;
        }
    }
    const onClick = () => {
        if (subMenu && subMenu.length > 0) {
            dispatch(menuStatus(!headerStatus));
        } else {
            navigation(`${link}`);
            dispatch(menuStatus(false));
        }
    }
    return (
        <>
            <div className={`${setStyle()}`} onClick={onClick} >

                <span className="text">{icon}  {name ? name : ""}  </span>
                <Arrowleft color={(location.pathname === link && !userProfile && headerStatus === false) || (subMenu && subMenu.length > 0 && headerStatus === true) ? "#ffffff" : "#000000"} />
            </div>
            {isMini ?
                <></>
                :
                <Collapse in={headerStatus}>
                    {headerStatus && subMenu && subMenu?.length > 0 && subMenu?.map((item: any, index: string) => {
                        return (
                            <Link to={item?.path} className={`${location.pathname === item?.path ? "active-sunmenu" : ""} submenu`} >
                                {location.pathname === item?.path &&
                                    <span className="active-sunmenu-circle">
                                    </span>
                                }
                                {item.name}  </Link>
                        )
                    })}
                </Collapse>
            }
        </>
    )
}
const mapStateToProps = (dispatch: any) => {
    return {
        dispatch,
        userData: dispatch.general.userData,
        headerStatus: dispatch.general.headerStatus,
    };
};
export default connect(mapStateToProps)(HeaderItem);